/**
 * state/reducers.js
 * Чистая функция-редьюсер для управления состоянием виджета.
 * Не содержит побочных эффектов — только трансформации состояния.
 */
import { ACTIONS, SCREENS } from '@/utils/constants';

/** Начальное состояние виджета */
export const initialState = {
  /** Открыт ли виджет */
  isOpen: false,

  /** Текущий экран */
  screen: SCREENS.LANGUAGE,

  /** История экранов для кнопки «Назад» */
  screenHistory: [],

  /** Выбранный язык */
  language: 'en',

  /** ID выбранного мероприятия (для экрана деталей) */
  selectedEventId: null,

  /** Данные пользователя (сущность User) */
  user: {
    id: null,             // UUID, заполняется при инициализации
    language: 'en',
    createdAt: null,
    lastActivity: null,
    interests: {          // заполняются в ходе опроса
      scenario: null,
      industry: null,
      goal: null,
      geography: null,
      format: null,
    },
    leadData: {
      name: '',
      company: '',
      email: '',
      phone: '',
      question: '',
      telegram: '',
      message: '',
    },
    channel: null,        // 'chat' | 'email' | 'telegram'
  },
};

/** Редьюсер */
export function widgetReducer(state, action) {
  switch (action.type) {

    case ACTIONS.TOGGLE_OPEN:
      return { ...state, isOpen: !state.isOpen };

    case ACTIONS.SET_OPEN:
      return { ...state, isOpen: action.payload };

    case ACTIONS.SET_SCREEN: {
      if (action.payload === SCREENS.WELCOME) {
        return { ...state, screen: SCREENS.WELCOME, screenHistory: [] };
      }

      const shouldPush =
        action.payload !== state.screen &&
        state.screen !== SCREENS.LANGUAGE;
      return {
        ...state,
        screen: action.payload,
        screenHistory: shouldPush
          ? [...state.screenHistory, state.screen]
          : state.screenHistory,
      };
    }

    case ACTIONS.GO_BACK: {
      if (state.screenHistory.length === 0) return state;
      const history = [...state.screenHistory];
      const previous = history.pop();
      return { ...state, screen: previous, screenHistory: history };
    }

    case ACTIONS.GO_MENU:
      return { ...state, screen: SCREENS.WELCOME, screenHistory: [] };

    case ACTIONS.SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
        user: { ...state.user, language: action.payload },
      };

    case ACTIONS.SET_LEAD_FIELD:
      return {
        ...state,
        user: {
          ...state.user,
          leadData: {
            ...state.user.leadData,
            [action.payload.field]: action.payload.value,
          },
        },
      };

    case ACTIONS.SET_LEAD_DATA:
      return {
        ...state,
        user: {
          ...state.user,
          leadData: {
            ...state.user.leadData,
            ...action.payload,
          },
        },
      };

    case ACTIONS.SET_INTERESTS:
      return {
        ...state,
        user: {
          ...state.user,
          interests: {
            ...state.user.interests,
            [action.payload.field]: action.payload.value,
          },
        },
      };

    case ACTIONS.SET_USER_FIELD:
      return {
        ...state,
        user: {
          ...state.user,
          [action.payload.field]: action.payload.value,
        },
      };

    case ACTIONS.SET_SELECTED_EVENT:
      return { ...state, selectedEventId: action.payload };

    case ACTIONS.RESET:
      return {
        ...initialState,
        isOpen: state.isOpen,
        language: state.language,
        screenHistory: [],
        user: {
          ...initialState.user,
          id: state.user.id,        // сохраняем UUID пользователя
          language: state.language,
        },
      };

    default:
      return state;
  }
}
